module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_5010.858ec002.png";